import api from './api';

export const productionStageService = {
  getAll: () => api.get('/production-stages/'),
  create: (stageData) => api.post('/production-stages/', stageData),
  update: (id, stageData) => api.put(`/production-stages/${id}`, stageData),
  delete: (id) => api.delete(`/production-stages/${id}`),
};
